import {FilterValue, StringOperator} from 'common/widgets/property-filter-menu/models/types';

export interface Bucket {
  bucketSize: number;
  groups?: number[] | null;
  max: number;
  min: number;
  offset?: number;
  disabled?: boolean;
  unit?: string;
}

export enum BucketType {
  Even = `even`,
  Varied = `varied`,
  None = `no`,
}

export interface BucketUpdateEventDetail {
  bucket: Bucket | StringBucket;
  isValid: boolean;
}

interface StringBucketEntry {
  filterValue: FilterValue;
  filterOperator: StringOperator;
  renamed: string;
}

export type StringBucket = StringBucketEntry[];

export enum DateTab {
  Iso = `iso`,
  Unit = `unit`,
}
